export default __webpack_public_path__ + "static/media/Saral-Pension-Brochure.db90a1ce.pdf";